<div id="dept-physical-edu" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Physical Education</h2>
    <p class="inner-lead mt-3">
      The Department of Physical Education at Shah Satnam Ji Girls' College, Sirsa promotes physical fitness, sportsmanship and healthy living. The college has state-of-the-art playgrounds and sports facilities enabling students to excel at State, National and International levels.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>Physical Education as a subject in BA</li>
      <li>D.P.Ed. (Diploma in Physical Education)</li>
      <li>B.P.Ed. (Bachelor of Physical Education)</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Sports Available</h4>
    <ul class="inner-lead">
      <li>Cricket &bull; Hockey &bull; Badminton &bull; Football</li>
      <li>Roller Skating &bull; Judo &bull; Kabaddi &bull; Athletics</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Ms. Naresh Rani</td><td>M.P.Ed</td></tr>
          <tr><td>2</td><td>Ms. Raman</td><td>M.P.Ed</td></tr>
          <tr><td>3</td><td>Ms. Anita Rani</td><td>M.P.Ed</td></tr>
          <tr><td>4</td><td>Ms. Gurmeet Kaur</td><td>M.P.Ed</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <ul class="inner-lead">
      <li>Annual Athletic Meet</li>
      <li>Yoga and Sudhi Kriya Sessions</li>
      <li>Yoga Protocol Workshop</li>
    </ul>

  </div>
</div>
